/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seemly_Noble_Rat_EvokeInputs */

const en_seemly_noble_rat_evoke = /** @type {(inputs: Seemly_Noble_Rat_EvokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promoters`)
};

const de_seemly_noble_rat_evoke = /** @type {(inputs: Seemly_Noble_Rat_EvokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promotoren`)
};

/**
* | output |
* | --- |
* | "Promoters" |
*
* @param {Seemly_Noble_Rat_EvokeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seemly_noble_rat_evoke = /** @type {((inputs?: Seemly_Noble_Rat_EvokeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seemly_Noble_Rat_EvokeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seemly_noble_rat_evoke(inputs)
	return de_seemly_noble_rat_evoke(inputs)
});